<!-- 网络安全等级保护解决方案 -->
<template>
  <div class="page_html">
    <banner :title="title" />
    <div class="introduce">
      <p class="sub_title">
        等保工作步骤
      </p>
      <div class="steps">
        <div
          v-for="(item, index) in steps"
          :key="index"
          class="step"
        >
          <img
            :src="item.src"
            alt=""
          >
        </div>
      </div>
    </div>

    <div class="introduce bg">
      <p class="sub_title">
        等保对象备案
      </p>
      <div class="records">
        <div
          v-for="item in records"
          :key="item.id"
          class="record"
        >
          <img
            :src="item.src"
            alt=""
          >
          <div class="title">
            {{ item.grade }}
          </div>
          <div class="text">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        等保2.0基本框架
      </p>
      <div class="constructor">
        <img
          src="@/assets/solution/gradeProtection/management.png"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
import banner from '@/views/solution/components/banner.vue'
export default {
  name: 'ProtectionGrade',
  components: {
    banner
  },
  data() {
    return {
      title: '网络安全等级保护解决方案',
      steps:
        [
          { src: require('@/assets/solution/gradeProtection/第一阶段.png') },
          { src: require('@/assets/solution/gradeProtection/第二阶段.png') },
          { src: require('@/assets/solution/gradeProtection/第三阶段.png') },
          { src: require('@/assets/solution/gradeProtection/第四阶段.png') },
          { src: require('@/assets/solution/gradeProtection/第五阶段.png') }
        ],

      records: [
        {
          id: 1,
          src: require('@/assets/solution/gradeProtection/图层917.png'),
          grade: '省级',
          text: '省级单位将资料交给省公安网安总队'
        },
        {
          id: 2,
          src: require('@/assets/solution/gradeProtection/图层915.png'),
          grade: '市级',
          text: '各地级市的单位将定级资料交给各自地级市的网安支队'
        },
        {
          id: 3,
          src: require('@/assets/solution/gradeProtection/图层916.png'),
          grade: '县级',
          text: '先将资料交到区县网安大队，再由区县网安大队转交地级市网安支队进行备案'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page_html {
  height: 100%;

  .steps {
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 60px 0 126px;

    .step {
      width: 19%;
      height: 220px;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        height: 100%;

      }

      &:nth-child(2n) {
        box-shadow: 0px 0px 5px 5px #EAEEF8;
      }
    }
  }

  .records {
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding-top: 60px;

    .record {
      width: 32%;
      display: flex;
      height: 408px;
      border-radius: 15px;
      flex-direction: column;
      align-items: center;
      box-shadow: 0px 0px 20px #D9E0F3;

      img {
        width: 100px;
        height: 100px;
        margin: 46px 0 31px;
      }

      .title {
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3879F6;
        line-height: 40px;
        margin-bottom: 47px;
      }

      .text {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        margin: 0 60px;
        text-align-last: center;

      }
    }
  }

  .constructor {
    width: 70%;
    margin: 0 auto 120px;
    padding-top: 20px;
    display: flex;
    justify-content: center;

    img {
      max-width: 100%;
    }
  }

  .bg {
    padding: 120px 0 140px;
    background: #FAFBFF;
  }

}

@media screen and (min-width: 1200px) and (max-width: 1350px) {

  .page_html .records,
  .page_html .constructor,
  .page_html .steps {
    width: 85% !important;
  }

  .page_html .records .record .text{
    font-size: 17px;
  }
  .page_html .records .record .title{
    font-size: 33px;
  }

}

@media screen and (min-width: 1350px) and (max-width: 1500px) {

  .page_html .records,
  .page_html .constructor,
  .page_html .steps {
    width: 80% !important;
  }
  .page_html .records .record .text{
    font-size: 19px;
  }
  .page_html .records .record .title{
     font-size: 30px;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1700px) {

  .page_html .records,
  .page_html .constructor,
  .page_html .steps {
    width: 75% !important;
  }

}
</style>
